export default "__VITE_ASSET__Jokadmp8__"